import type React from 'react';

import { MembershipAwareness } from './entry';
import { useMembershipAwarenessFormDataQuery } from './hooks/useMembershipAwarenessFormDataQuery';
import type { PublicProps } from './shared/types';

export const MembershipAwarenessWithData: React.FC<PublicProps> = (props) => {
	const { data: formData } = useMembershipAwarenessFormDataQuery();

	// not displaying a loader when in a loading state because it might result in nothing
	if (!formData) return null;

	return <MembershipAwareness {...props} formData={formData} />;
};
